/** LUFE cloud ids have no extension; `temp-*` local uploads must use `/files`. */
export function isLufeCloudFileName(filename?: string | null): boolean {
  if (!filename) return false;
  if (filename.startsWith('temp-')) return false;
  return !filename.includes('.');
}
